import { IValues } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import {
  getStandardIncomePoints,
  IIncomeRatioRange,
  parseIncomeRatioRanges,
} from "@rentiohq/shared-frontend/dist/utils/rentmatch.utils";
import { EField, IExtraData } from "./schema.rentmatchScoreBroker.types";

/**
 * One open-ended band is already a table: every rent, this multiple. The reader
 * of the stored value accepts that, so this screen has to as well, or a table
 * somebody narrowed to a single band would be replaced by the standard on
 * sight and written back that way.
 */
const MINIMUM_ROWS = 1;

/**
 * Whatever the office stored, however many bands it has.
 *
 * An office that saved nothing starts from the built-in scale written out as
 * bands: a starting point to change, not a claim about how it scores today.
 * While nothing is stored the screen shows the scale itself instead.
 *
 * The count is not fixed. Reading a fixed three would quietly drop the fourth
 * band an office added and save the table back without it, and the scoring
 * itself has never cared how many there are: it takes the first band the rent
 * falls into.
 */
export const getIncomeRangeRows = (
  stored?: string | unknown[] | null,
): IIncomeRatioRange[] => {
  const parsed = parseIncomeRatioRanges(stored);

  return parsed && parsed.length >= MINIMUM_ROWS
    ? parsed
    : getStandardIncomePoints();
};

export const getInitialValues = ({ broker }: IExtraData): IValues => ({
  [EField.IncomeRanges]: getIncomeRangeRows(broker.rentmatchIncomeRanges),
});
